import { AlternativeAutoComplete } from "common/form/autoComplete/_alternativeAutoComplete"
import { Option } from "common/form/autoComplete/_option"
import { useCreateTeacherForm } from "../../hook/useCreateTeacherForm"

export const Province = () => {
    const {province} = useCreateTeacherForm()
    const {methods} = province

    return (
        <div>
            <AlternativeAutoComplete
                // main input
                inputProps={{
                    categoryList: [], 
                    categoryHidden: true,
                    readOnly: true,
                    categoryValue: { name: 'Vui lòng chọn tỉnh của ĐLC2', value: '' },
                    label: 'Tỉnh thành',
                    placeholder: 'Vui lòng chọn tỉnh của ĐLC2',
                    value: province?.value?.name,
                }}
                menuProps={{
                    empty:
                    province.list.length <= 0
                        ? 'Không tìm thấy tỉnh của ĐLC2'
                        : '',
                }}
                searchInputProps={{
                    placeholder: 'Tìm kiếm tỉnh của ĐLC2',
                    onChange: methods.onKeywordChange,
                }}
            >
                {
                    province?.list?.map((item, index) => (
                        <Option
                            key={index}
                            className="teacher__option-text"
                            data-active={province?.value?.name === item.name}
                            onClick={() => methods?.onChange(item)}
                            style={{marginTop: 16, cursor:'pointer'}}
                        >
                            {item.name}
                        </Option>
                    ))}
            </AlternativeAutoComplete>
        </div>
    )
}